module.exports = __webpack_public_path__ + "img/MSLNG2_Cover.b792980d.jpg";